import type { SVGProps } from 'react'
interface SvgReceiptLongProps extends SVGProps<SVGSVGElement> {
  size?: string | number
}

const SvgReceiptLong = ({ size = '1em', ...props }: SvgReceiptLongProps) => (
  <svg height={size} viewBox="0 0 18 18" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="receipt-long_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#receipt-long_svg__a)">
      <path d="M4.522 16.774a2.37 2.37 0 0 1-1.74-.717 2.37 2.37 0 0 1-.716-1.74V11.92h2.317V1.397L5.55 2.549l1.153-1.152 1.152 1.152 1.153-1.152 1.153 1.152 1.153-1.152 1.152 1.152 1.152-1.152 1.151 1.152 1.166-1.152v12.92q0 1.023-.717 1.74a2.37 2.37 0 0 1-1.74.716zm8.956-1.707q.318 0 .534-.215a.73.73 0 0 0 .216-.535V3.876H6.09v8.043h6.638v2.398q0 .319.215.535a.73.73 0 0 0 .535.215M6.84 6.911v-1.5h4.388v1.5zm0 2.25v-1.5h4.388v1.5zm5.888-2.25a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535q0-.318.215-.534a.73.73 0 0 1 .535-.216q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215m0 2.25a.73.73 0 0 1-.535-.215.73.73 0 0 1-.215-.535q0-.318.215-.534a.73.73 0 0 1 .535-.216q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215m-8.206 5.906h6.5v-1.441h-7.25v.691q0 .319.216.535a.73.73 0 0 0 .534.215" />
    </g>
  </svg>
)
export default SvgReceiptLong
